import { defineStore } from "pinia"
import { computed, ref } from "vue"
import { usePointer } from "@vueuse/core"
import { BaseException } from "@/exceptions/base-exception.exception"

export const useAppStore = defineStore("appStore", () => {
  const initialOrdersFetchInitiated = ref(false)
  const initialBaseCollectionsFetchInitiated = ref(false)
  const initialTransactionsAndMutationsFetchInitiated = ref(false)
  const currentError = ref<BaseException | null>(null)

  const { x, y } = usePointer()

  const cursorX = computed(() => x.value)
  const cursorY = computed(() => y.value)

  function setError(error: BaseException | null) {
    currentError.value = error
  }

  function clearError() {
    currentError.value = null
  }

  return {
    initialOrdersFetchInitiated,
    initialBaseCollectionsFetchInitiated,
    initialTransactionsAndMutationsFetchInitiated,
    cursorX,
    cursorY,
    currentError,
    setError,
    clearError
  }
})
